import { render } from "./TaskList.vue?vue&type=template&id=1a60071e&scoped=true"
import script from "./TaskList.vue?vue&type=script&lang=js"
export * from "./TaskList.vue?vue&type=script&lang=js"

import "./TaskList.vue?vue&type=style&index=0&id=1a60071e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a60071e"]])

export default __exports__